/**
 * Component Registry for Rr Living Landing Page Theme
 * 
 * Extends the base landing-page theme registry with Rr Living Landing Page specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-landing-page/registry';
import { Footer } from './components/Footer';
import { NationalOpenHouseBanner } from './components/NationalOpenHouseBanner';
import { SpecialOffers } from './components/SpecialOffers';

/**
 * Rr Living Landing Page specific component overrides.
 * These components have been customized for the Rr Living Landing Page brand.
 * 
 * Example:
 * import { Footer } from './components/Footer';
 * 
 * const rrlivinglandingpageOverrides: Partial<ComponentRegistry> = {
 *   Footer,
 * };
 */
const rrlivinglandingpageOverrides: Partial<ComponentRegistry> = {
  Footer,
  NationalOpenHouseBanner,
  SpecialOffers,
};

/**
 * Final merged registry for Rr Living Landing Page properties.
 * Inherits all components from the landing-page theme, with Rr Living Landing Page overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...rrlivinglandingpageOverrides,
};

export default registry;
